import { z } from 'zod'

export const schema = z.object({
  fund_name: z.string(),
  shareclass_code: z.string(),
  shareclass_sleeve: z.string(),
  isin: z.string(),
})

export type SchemaType = z.infer<typeof schema>
